import { cn } from "@apex/shared";

export interface LoadingViewProps {
  message?: string;
  className?: string;
}

function SkeletonCard() {
  return (
    <div className="apex-rounded-lg apex-border apex-border-border apex-bg-card apex-overflow-hidden" style={{ boxShadow: "var(--apex-shadow-card)" }}>
      {/* Image placeholder */}
      <div className="apex-skeleton" style={{ aspectRatio: "4/3" }} />
      {/* Content */}
      <div className="apex-p-4 apex-space-y-3">
        {/* Title */}
        <div className="apex-skeleton apex-h-5 apex-w-3/4" />
        {/* Description */}
        <div className="apex-skeleton apex-h-3 apex-w-full" />
        {/* Price + button row */}
        <div className="apex-flex apex-items-center apex-justify-between apex-pt-2">
          <div className="apex-skeleton apex-h-6 apex-w-20" />
          <div className="apex-skeleton apex-h-8 apex-w-24 apex-rounded-md" />
        </div>
      </div>
    </div>
  );
}

export function LoadingView({
  message = "Loading configurator...",
  className,
}: LoadingViewProps) {
  return (
    <div
      className={cn(
        "apex-flex apex-flex-col apex-min-h-[400px] apex-p-6",
        className
      )}
    >
      {/* Header skeleton */}
      <div className="apex-mb-6 apex-space-y-2">
        <div className="apex-skeleton apex-h-6 apex-w-48" />
        <div className="apex-skeleton apex-h-3 apex-w-32" />
      </div>

      {/* Skeleton grid matching ItemSelectionView layout */}
      <div className="apex-grid apex-grid-cols-1 sm:apex-grid-cols-2 lg:apex-grid-cols-3 apex-gap-4 apex-stagger">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>

      {/* Subtle loading text */}
      <p className="apex-text-xs apex-text-muted-foreground apex-text-center apex-mt-6 apex-animate-fade-in">
        {message}
      </p>
    </div>
  );
}
